import api from "./index";

import { IUsernamePassword } from "../interfaces/services";

export const signIn = async (payload: IUsernamePassword) => {
    try {
        const res = await api.get(`admins/sign-in?username=${payload.username}&password=${payload.password}`);
        return res.data;
    } catch (error: any) {
        throw error?.response?.data;
    };
};